import { Injectable } from '@angular/core';

import { CurrentContextService } from '../current-context/current-context.service';

/**
 * A very basic (but useful) service that can be referenced to get a support link
 * that can be used anywhere in the app.
 * If the URL for our support link changes, it can be changed here as a one-liner.
 * If we need multiple support links, this service can be expanded to support more.
 */
@Injectable({
  providedIn: 'root',
})
export class SupportLinkService {
  public supportTicketLink = `https://${this.context.env?.zendesk?.host}/hc/en-us/requests/new`;
  public generalSupportLink = `https://${this.context.env?.zendesk?.host}`;

  constructor(private context: CurrentContextService) {}
}
